import { CompanyAPI } from '@api/buser-http-client';

const calculateFreightReduction = (busId, grupoId) => {
  const params = {
    new_bus_id: busId,
    group_id: grupoId,
  };

  return CompanyAPI.calculateFreightReduction(params)
    .then(({ data }) => data)
    .catch((error) => Promise.reject(error.response?.data || error.response || error));
};

export { calculateFreightReduction };
